import { useEffect, useState } from "react";
import {useLocation, useNavigate} from "react-router-dom";
import CommonNavBar from "views/components/CommonNavBar";
import styles from "./questContent.module.less";
import {Divider, Toast} from "react-vant";
import { getJumpLink } from "api/home";
import DSBridge from "dsbridge";

function QuestContent() {
    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const content = searchParams.get("content")
    const title = searchParams.get("title")
    
    const [jumpLink, setJumpLink] = useState("");

    const getJumpLinkData = async () => {
        try {
            const res = await getJumpLink();
            if (res.code === 200) {
                setJumpLink(res.data?.path);
            }
        } catch (e) {
            console.log(e);
        }
    };

    useEffect(() => {
        getJumpLinkData();
    }, []);

    const handleClickWeixin = () => {
        if (!jumpLink) {
            Toast.info("暂无跳转链接");
            return;
        }
        try {
            if (DSBridge.hasNativeMethod("route.navigation")) {
                DSBridge.call(
                    "route.navigation",
                    {
                        route: "miniProgram",
                        mid: "gh_ce82ce6b1629",
                        path: jumpLink,
                    },
                    (back) => {
                        console.log(back);
                    }
                );
            }
        } catch (e) {
            console.log(e);
        }
    };

    return (
        <div>
            <CommonNavBar title={"常见问题"}
                          onClickBack={() => {
                              navigate(-1);
                          }}
            />
            <div className={styles["content-title"]}>
                {title}
            </div>
            <Divider/>
            <div className={styles["content-container"]} dangerouslySetInnerHTML={{ __html: content }} />
            <Divider/>
            <div className={styles["bottom-container"]} onClick={handleClickWeixin}>
                没有解决问题？联系人工客服
            </div>
        </div>
    )
}

export default QuestContent;

